export class Club {
  added: Date;
  address: string;
  awaycolor: number;
  city: string;
  clubAllinLogo: string;
  clubBGcolor: string;
  clubBGimage: string;
  clubID: number;
  clubfacebook: string;
  clublogo: string;
  clubpresident: string;
  clubpresidentemail: string;
  clubpresidentphone: string;
  clubpublicbanner: string;
  clubstripeaccountID: string;
  clubStripeAccounts: any[];
  clubtwitter: string;
  clubwebsite: string;
  countryID: number;
  homecolor: number;
  location: string;
  name: string;
  phone: string;
  stateID: number;
  stripePercentFee: number;
  stripeTransactionFee: number;
  updated: Date;
  zip: string;
  homeJersey: string;
  awayJersey: string;

  constructor(data: any = {}) {
    Object.keys(data).forEach(key => {
      this[key] = data[key];
    });
    try {
      this.added = new Date(data.added);
      this.updated = new Date(data.updated);
    } catch (e) {
      console.log(e);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/models/club/club.ts